import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'TWO_FACTOR_SETTINGS';

export const {
    action: getTwoFactorImage,
    success: getTwoFactorImageSuccess,
    failed: getTwoFactorImageFailed,
} = createAction(
    `${domain}/GET_TWO_FACTOR_IMAGE`,
    (accessToken: string) => ({accessToken}),
    (imageUrl: string, secret: string) => ({imageUrl, secret}),
);

export const {
    action: activateTwoFactor,
    success: activateTwoFactorSuccess,
    failed: activateTwoFactorFailed,
} = createAction(`${domain}/ACTIVATE_TWO_FACTOR`, (accessToken: string, secret: string, code: string) => ({
    accessToken,
    secret,
    code,
}));

export const {
    action: disableTwoFactor,
    success: disableTwoFactorSuccess,
    failed: disableTwoFactorFailed,
} = createAction(`${domain}/DISABLE_TWO_FACTOR`, (accessToken: string, password: string) => ({accessToken, password}));

export const {action: showModal} = createAction(`${domain}/SHOW_MODAL`, () => ({}));

export const {action: hideModal} = createAction(`${domain}/HIDE_MODAL`, () => ({}));
